import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Text from '@mui/material/Typography'

import useDevice from '@/hooks/useDevice'

const QuoteTile = ({
    imageSrc,
    text,
    logo,
}: {
    imageSrc: string
    text: string
    logo?: JSX.Element
}) => {
    const { smScreen, xsScreen } = useDevice()

    return (
        <Box
            sx={{
                backgroundImage: `url(${imageSrc})`,
                backgroundSize: 'cover',
                height: '220px',
                width: smScreen ? '100%' : '420px',
                borderRadius: `16px`,
                padding: smScreen
                    ? `32px 24px 32px ${xsScreen ? '64px' : '200px'}`
                    : '32px 32px 32px 160px',
            }}
        >
            <Stack
                spacing={3}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    height: '100%',
                }}
            >
                <Text
                    sx={{ fontSize: '22px', lineHeight: '26.4px', fontWeight: 400 }}
                    component="span"
                >
                    {text}
                </Text>
                {logo && <Box>{logo}</Box>}
            </Stack>
        </Box>
    )
}

export default QuoteTile
